import React, { useEffect, useState, useRef } from "react";
import { LinkContainer } from "react-router-bootstrap";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../redux/actions/userActions";
import SearchBox from "./SearchBox";
import { useLocation } from "react-router-dom";
import { Badge } from "react-bootstrap"; // Add Badge to your imports
import logo from "../assets/Logo.png"

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // Get userInfo from Redux store
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const cart = useSelector((state) => state.cart);
const cartItems = cart.cartItems || [];

const cartCount = cartItems.reduce((acc, item) => acc + item.qty, 0);


  // State to hold the fresh user info fetched from backend
  const [freshUserInfo, setFreshUserInfo] = useState(null);

  // Navbar expanded state for controlling hamburger menu
  const [expanded, setExpanded] = useState(false);

  // Ref for header to detect outside clicks
  const headerRef = useRef(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!userInfo || !userInfo.token) {
        setFreshUserInfo(null);
        return;
      }
      try {
        const response = await fetch("/api/users/profile", {
          headers: {
            Authorization: `Bearer ${userInfo.token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setFreshUserInfo(data.user);
        } else {
          setFreshUserInfo(null);
        }
      } catch (error) {
        setFreshUserInfo(null);
      }
    };

    fetchUserProfile();
  }, [userInfo]);

  // Close navbar if clicking outside of header/navbar area
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // Close navbar when route changes (e.g. clicking About Us)
useEffect(() => {
  setExpanded(false);
}, [location.pathname]);



  // Use the fresh profile info if available, else fall back to userInfo from Redux
  const currentUser = freshUserInfo || userInfo;

  const handleLogout = () => {
    dispatch(logout());
    setFreshUserInfo(null);
  };

  // Show search icon only on Home or Cart pages
  const showSearchBox =
    location.pathname === "/" || location.pathname.startsWith("/cart");

  return (
    <header
      ref={headerRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        width: "100%",
        zIndex: 100,
        background: "var(--background-offwhite)",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
    >
      <Navbar
        bg="light"
        variant="light"
        expand="lg"
        collapseOnSelect
        expanded={expanded}
        onToggle={(isExpanded) => setExpanded(isExpanded)}
        style={{ minHeight: "80px" }}
      >
        <Container className="d-flex align-items-center justify-content-between">
          {/* Left: Brand */}
          <LinkContainer to="/">
  <Navbar.Brand>
    <img
      src={logo}
      alt="SYUKRA Logo"
      style={{
        height: "40px",
        width: "auto",
        objectFit: "contain",
      }}
    />
  </Navbar.Brand>
</LinkContainer>

          {/* Right side: Search (desktop + mobile) and Toggle grouped */}
          <div className="d-flex align-items-center" style={{ gap: "0px" }}>
            {/* Mobile Search Icon */}
            {showSearchBox && (
              <div className="d-flex d-lg-none align-items-center">
                <SearchBox />
              </div>
            )}

<div className="d-flex d-lg-none align-items-center position-relative">
  <LinkContainer to="/cart">
    <Nav.Link className="position-relative">
      <i className="fas fa-shopping-cart"></i>

      {cartCount > 0 && (
        <span
  className="position-absolute top-0 start-100 bg-danger text-white"
  style={{
    transform: "translate(-90%, 0%)",
    width: "16px",
    height: "16px",
    fontSize: "0.6rem",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "1",
  }}
>
  {cartCount}
</span>

      )}
    </Nav.Link>
  </LinkContainer>
</div>



            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          </div>

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center" style={{ gap: "1rem" }}>
              {/* Desktop Search Icon */}
              {showSearchBox && (
                <div className="d-none d-lg-flex align-items-center">
                  <SearchBox />
                </div>
              )}

<LinkContainer to="/cart">
  <Nav.Link className="hide-below-992 position-relative">
    <i className="fas fa-shopping-cart me-1"></i> Cart

    {cartCount > 0 && (
      <span
        className="position-absolute top-0 start-100 bg-danger text-white"
        style={{
          transform: "translate(-45%, 25%)",
          width: "16px",
          height: "16px",
          fontSize: "0.6rem",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          lineHeight: "1",
        }}
      >
        {cartCount}
      </span>
    )}
  </Nav.Link>
</LinkContainer>


              <LinkContainer to="/about">
                <Nav.Link>About Us</Nav.Link>
              </LinkContainer>

              {currentUser ? (
                <NavDropdown
                  title={
                    currentUser.name.split(" ").length > 1
                      ? currentUser.name.split(" ").slice(0, 2).join(" ")
                      : currentUser.name
                  }
                  id="username"
                >
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link>
                    <i className="fas fa-user"></i> SignIn
                  </Nav.Link>
                </LinkContainer>
              )}

              {currentUser && currentUser.isAdmin && (
                <NavDropdown title="admin" id="useradmin">
                  <LinkContainer to="/admin/users">
                    <NavDropdown.Item>Users</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/products">
                    <NavDropdown.Item>Products</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/orders">
                    <NavDropdown.Item>Orders</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/category-discounts">
                    <NavDropdown.Item>Category Discounts</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="admin/create-coupon">
                    <NavDropdown.Item>Coupons</NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
